(() => {
  const DESKTOP_QUERY = '(min-width: 900px)';

  const buildDot = ({ index, active, onClick }) => {
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'tap-area';
    button.setAttribute('aria-current', active ? 'true' : 'false');

    const srOnly = document.createElement('span');
    srOnly.className = 'sr-only';
    srOnly.textContent = String(index + 1);
    button.appendChild(srOnly);

    if (!active) {
      button.addEventListener('click', onClick);
    }

    return button;
  };

  const initSection = (sectionEl) => {
    const carousel = sectionEl.querySelector('scroll-carousel.daily-featured-collection__carousel');
    const dots = sectionEl.querySelector('[data-daily-featured-desktop-dots]');

    if (!carousel || !dots) return;
    if (dots.dataset.bound === 'true') return;
    dots.dataset.bound = 'true';

    const mq = window.matchMedia(DESKTOP_QUERY);

    const render = () => {
      if (!mq.matches) {
        dots.hidden = true;
        return;
      }

      const totalPages = Math.max(1, Number(carousel.totalPages) || 1);
      const current = Math.min(
        Math.max(Number(carousel.selectedIndexAmongVisible) || 0, 0),
        totalPages - 1
      );

      dots.replaceChildren();

      if (totalPages <= 1 || !carousel.classList.contains('is-scrollable')) {
        dots.hidden = true;
        return;
      }

      dots.hidden = false;

      for (let i = 0; i < totalPages; i += 1) {
        dots.appendChild(
          buildDot({
            index: i,
            active: i === current,
            onClick: () => carousel.select(i),
          })
        );
      }
    };

    const schedule = () => requestAnimationFrame(render);

    carousel.addEventListener('carousel:select', schedule);
    carousel.addEventListener('carousel:change', schedule);
    carousel.addEventListener('scroll:edge-nearing', schedule);
    carousel.addEventListener('scroll:edge-leaving', schedule);

    if (window.ResizeObserver) {
      new ResizeObserver(schedule).observe(carousel);
    } else {
      window.addEventListener('resize', schedule);
    }

    if (mq.addEventListener) {
      mq.addEventListener('change', schedule);
    } else {
      mq.addListener(schedule);
    }

    schedule();
  };

  const initAll = () => {
    document
      .querySelectorAll('.shopify-section--daily-featured-collection')
      .forEach(initSection);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }
})();
